// Libraries
import { Icon, IconProps } from '@chakra-ui/react';

/**
 * Component that renders the Hour Glass Icon.
 * @param {IconProps} props - The IconProps for the HourGlassIcon component.
 * @returns {ReactElement} The HourGlassIcon component.
 */
export const HourGlassIcon = (props: IconProps) => {
  const { color = '#25CAD2', ...rest } = props;
  return (
    <Icon viewBox='0 0 44 39' color={color} id='hour-glass-icon' {...rest}>
      <path
        d='M21.625 27.6328C21.625 21.6634 26.4681 16.8203 32.4375 16.8203C38.4069 16.8203 43.25 21.6634 43.25 27.6328C43.25 33.6022 38.4069 38.4453 32.4375 38.4453C26.4681 38.4453 21.625 33.6022 21.625 27.6328ZM33.5713 22.8273C33.5713 22.1665 33.0983 21.6259 32.3699 21.6259C31.7767 21.6259 31.1685 22.1665 31.1685 22.8273V27.6328C31.1685 28.2936 31.7767 28.8342 32.3699 28.8342H36.0417C36.7024 28.8342 37.2431 28.2936 37.2431 27.6328C37.2431 26.972 36.7024 26.4314 36.0417 26.4314H33.5713V22.8273Z'
        fill='currentColor'
      />
      <path
        d='M0 2.40278C0 1.07599 1.07599 0 2.40278 0H26.4306C27.7596 0 28.8333 1.07599 28.8333 2.40278C28.8333 3.72956 27.7596 4.80556 26.4306 4.80556V5.63001C26.4306 8.81519 25.1616 11.8712 22.909 14.1238L17.8181 19.2222L20.5137 21.8578C19.6878 23.5848 19.2222 25.5896 19.2222 27.6319C19.2222 32.0996 21.4448 36.0492 24.8387 38.4444H2.40278C1.07599 38.4444 0 37.3707 0 36.0417C0 34.7126 1.07599 33.6389 2.40278 33.6389V32.8129C2.40278 29.6293 3.66874 26.5732 5.92135 24.3206L11.0152 19.2222L5.92135 14.1238C3.66874 11.8712 2.40278 8.81519 2.40278 5.63001V4.80556C1.07599 4.80556 0 3.72956 0 2.40278ZM7.20833 4.80556V5.63001C7.20833 7.05666 7.62882 8.43976 8.34214 9.61111H20.4236C21.2045 8.43976 21.625 7.05666 21.625 5.63001V4.80556H7.20833Z'
        fill='#92E4E8'
      />
    </Icon>
  );
};
